import $ from 'jquery'

import form from '../../edit/form/form'

import documentUpdate from '../../lib/documentUpdate'
import documentRemove from '../../lib/documentRemove'

import * as timecode from '../../../../lib/timecode'

export function getName(){
  return 'archive/contact'
}

export function getTableColumns(o,item){

  var lang = o.store('lang')

  var columns = [
    {
      id: 'done',
      value: item.done,
      type: o.type.toggle,
    },
    {
      id: 'name',
      value: item.name,
      type: o.type.text,
    },
    {
      id: 'email',
      value: item.email,
      type: o.type.text,
    },
    {
      id: 'message',
      value: item.message,
      type: o.type.text,
    },
    {
      id: 'roll',
      value: item.roll,
      type: o.type.text,
      optional: true,
    },
    {
      id: 'start',
      value: item.start,
      type: o.type.timecode,
      optional: true,
    },
    {
      id: 'date',
      value: item.date,
      type: o.type.date,
    },
    {
      id: 'notes',
      value: item.notes,
      type: o.type.textLong,
      table: {
        width: 300,
        multiline: true,
      },
    },
    {
      id: 'user',
      value: item.user,
      type: o.type.text,
    },
    {
      id: 'editDate',
      value: item.editDate,
      type: o.type.date,
    },
  ]

  return columns

}

export function getTableData(o){

  var data =
    _.map(

      o.data.contact,

      function(item){

        var model = o.model.aContact
        var columns = model.getTableColumns(o,item)

        var click =
          function(e){
            if(item.roll && item.start){
              var roll = _.find(o.data.rolls, {roll: item.roll})
              var start = timecode.toSeconds(item.start)
              o.player.load(roll,start)
            }
            o.edit.set(item,model)
          }

        return {

          columns: columns,
          click: click,

        }

      }
    )

  return data

}

export function getFormFields(o,item){

  var lang = o.store('lang')

  if(!item){
    var item = {}
  }

  if(o.video){
    var start = timecode.toSmtp(o.video.currentTime)
  } else {
    var start = timecode.toSmtp(0)
  }

  var init = {
    roll: o.roll,
    start: start,
  }

  var fields = [
    {
      id: 'done',
      value: item.done,
      type: 'toggle',
      edit: true,
    },
    {
      id: 'name',
      value: item.name,
      type: 'text',
    },
    {
      id: 'email',
      value: item.email,
      type: 'text',
    },
    {
      id: 'message',
      value: item.message,
      type: 'textLong',
    },
    {
      id: 'roll',
      value: item.roll,
      type: 'text',
      init: init.roll,
    },
    {
      id: 'start',
      value: item.start,
      type: 'timecode',
      init: init.start,
    },
    {
      id: 'notes',
      value: item.notes,
      type: 'textLong',
      edit: true,
      optional: true,
    },

  ]

  return fields

}

export function insertForm(o,done){

}


export function remove(o,id,done){

  var data = o.data.contact
  var collection = 'a_markers'

  documentRemove(o,data,id,collection,done)

}

export function insert(o,item,done){

}

export function update(o,id,changes,done){

  var lang = o.store('lang')

  var data = o.data.contact
  var collection = 'contact'

  changes.push({
    id: 'user',
    value: o.store('email'),
  })

  changes.push({
    id: 'editDate',
    value: new Date(),
  })

  documentUpdate(o,data,id,changes,collection,done)

}



// WEBPACK FOOTER //
// ./src/client/view/admin/model/aContact/aContact.js